import { createBrowserRouter } from 'react-router-dom';

import { MainLayout } from 'app/layouts';
import { Api } from 'pages/Api';
import { BrokenLinks } from 'pages/BrokenLinks';
import { Catalog, Offer } from 'pages/Catalog';
import { Dashboard } from 'pages/Dashboard';
import { Finances } from 'pages/Finances';
import { Links } from 'pages/Links';
import { MyOffers } from 'pages/MyOffers';
import { NotFound } from 'pages/NotFound';
import { Notifications } from 'pages/Notifications';
import { CreatePostback, EditPostback, Postbacks } from 'pages/Postbacks';
import { Profile } from 'pages/Profile';
import { Reports } from 'pages/Reports';
import { ShortLink } from 'pages/ShortLink';
import { SourceDetail, Sources } from 'pages/Sources';
import { Telegram } from 'pages/Telegram';
import { Tools } from 'pages/Tools';
import { EMainRoutes } from 'shared/typings';

const appRouter = createBrowserRouter([
	{
		path: '/',
		element: <MainLayout />,
		errorElement: <MainLayout outlet={<NotFound />} />,
		children: [
			{
				path: EMainRoutes.DASHBOARD,
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.CATALOG,
				element: <Catalog />,
			},
			{
				path: `${EMainRoutes.CATALOG}/${EMainRoutes.OFFER}/:id`,
				element: <Offer />,
			},
			{
				path: EMainRoutes.MY_OFFERS,
				element: <MyOffers />,
			},
			{
				path: EMainRoutes.SOURCES,
				element: <Sources />,
			},
			{
				path: `${EMainRoutes.SOURCES}/:id`,
				element: <SourceDetail />,
			},
			{
				path: EMainRoutes.TOOLS,
				element: <Tools />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.SHORTLINK}`,
				element: <ShortLink />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.BROKEN_LINKS}`,
				element: <BrokenLinks />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.API}`,
				element: <Api />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.TELEGRAM}`,
				element: <Telegram />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.POSTBACKS}`,
				element: <Postbacks />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.POSTBACKS}/${EMainRoutes.CREATE}`,
				element: <CreatePostback />,
			},
			{
				path: `${EMainRoutes.TOOLS}/${EMainRoutes.POSTBACKS}/${EMainRoutes.EDIT}/:id`,
				element: <EditPostback />,
			},

			{
				path: EMainRoutes.NOTIFICATIONS,
				element: <Notifications />,
			},
			{
				path: EMainRoutes.FINANCES,
				element: <Finances />,
			},
			{
				path: EMainRoutes.REPORTS,
				element: <Reports />,
			},
			{
				path: EMainRoutes.PROFILE,
				element: <Profile />,
			},
			{
				path: EMainRoutes.LINKS,
				element: <Links />,
			},
		],
	},
]);

export default appRouter;
